<dialog
  #lastFactWarningDialog
  qai-dialog
  [heading]="lastFactWarningHeading"
  [description]="lastFactWarningDescription"
  (afterClose)="cancelLastFactDelete()"
>
  <div class="last-fact-warning-actions">
    <button qai-button kind="secondary" size="medium" (click)="cancelLastFactDelete()">
      {{ 'simulationBuilder.BUTTON_CANCEL' | transloco }}
    </button>
    <button qai-button kind="destructive" size="medium" (click)="confirmLastFactDelete()">
      {{ 'simulationBuilder.DELETE' | transloco }}
    </button>
  </div>
</dialog>

@if (isSelfAuthoringRoleplay()) {
  <app-accordion-card
    [title]="'simulationBuilder.MESSAGING_TITLE' | transloco"
    [subHeading]="'simulationBuilder.MESSAGING_SUBTITLE' | transloco"
    [expanded]="true"
  >
    <!-- <qai-badge
      status
      [shape]="'round'"
      [kind]="'green'"
      [size]="'xsmall'"
      [label]="(totalFactsCount() === 1 ? 'simulationBuilder.FACT_EXTRACTED_SINGULAR' : 'simulationBuilder.FACT_EXTRACTED_PLURAL') | transloco: { count: totalFactsCount() }"
    ></qai-badge> -->
    <!-- @if (reviewRequired()) {
      <qai-badge
        status
        [shape]="'round'"
        [kind]="'yellow'"
        [size]="'xsmall'"
        [label]="'simulationBuilder.REVIEW_REQUIRED_LABEL' | transloco"
      ></qai-badge>
    } -->
    <qai-badge
      controls
      [shape]="'rectangle'"
      [kind]="'default'"
      [size]="'xsmall'"
      [label]="'simulationBuilder.METHODOLOGY_WEIGHTING_LABEL' | transloco: { weight: messagingWeight() }"
    ></qai-badge>
    <div class="message-theme-container">
      <qai-dragable
        [listId]="'themes-list'"
        [items]="themesItems"
        [useDragHandle]="true"
        [dragHandleDisable]="readOnly"
        (itemsChange)="onThemesReordered($event)"
      >
        <ng-template #cardTemplate let-item>
          <div style="display: flex; align-items: flex-start; gap: 8px;">
            <messaging-theme
              style="flex: 1;"
              [messagingFactSection]="asFormGroup(item)"
              [messagingFactSectionFacts]="$any(asFormGroup(item).get('facts'))"
              [messagingFactSections]="messagingFactSections"
              [sectionUuid]="asFormGroup(item).get('uuid')?.value"
              [sectionName]="asFormGroup(item).get('name')?.value"
              [otherThemeListIds]="getOtherThemeListIds(item)"
              [isSelfAuthoringRoleplay]="true"
              (deleteRequested)="handleDeleteTheme($event)"
              (themeExpanded)="onThemeExpanded($event)"
            ></messaging-theme>
          </div>
        </ng-template>
      </qai-dragable>
    </div>
    <div class="add-theme add-theme--roleplay">
      <span #addThemeBtnWrapper>
        <button
          qai-button
          [shape]="'normal'"
          [kind]="'tertiary'"
          [size]="'medium'"
          [disabled]="readOnly || hasBlankThemeFact()"
          (click)="addTheme($event)"
        >
          <qai-icon kind="plus" size="'20px'" positionStart />
          <span>{{ 'simulationBuilder.ADD_NEW_THEME_BUTTON' | transloco }}</span>
        </button>
      </span>
      <qai-tooltip
        *ngIf="hasBlankThemeFact()"
        [qaiFloating]="addThemeBtnWrapper"
        [placement]="'above-center'"
        [events]="['hover']"
      >
        {{ 'simulationBuilder.BLANK_THEME_MESSAGE_TOOLTIP' | transloco }}
      </qai-tooltip>
    </div>
  </app-accordion-card>
} @else {
  <details-section
    [title]="'simulationBuilder.MESSAGING_TITLE' | transloco"
    [showDetails]="false"
    description="{{ detailsSectionDescription }}"
  >
    <div class="textarea-container" [formGroup]="form">
      <div [formGroup]="messagingPromptGroup">
        <qai-field [label]="messagingPromptLabel">
          <textarea
            qai-textarea
            autosize
            [maxLines]="30"
            qaiTrimLeading
            qaiPasteClean
            formControlName="promptText"
          ></textarea>
        </qai-field>
      </div>
    </div>

    <div class="message-theme-container">
      <qai-label [kind]="'secondary'" class="theme-label" [size]="'small'" [weight]="'regular'">
        {{themesLabel}}
      </qai-label>
      <qai-dragable
        [listId]="'themes-list'"
        [items]="themesItems"
        [useDragHandle]="true"
        [dragHandleDisable]="true"
        (itemsChange)="onThemesReordered($event)"
      >
        <ng-template #cardTemplate let-item>
          <div style="display: flex; align-items: flex-start; gap: 8px;">
            <messaging-theme
              style="flex: 1;"
              [messagingFactSection]="asFormGroup(item)"
              [messagingFactSectionFacts]="$any(asFormGroup(item).get('facts'))"
              [messagingFactSections]="messagingFactSections"
              [sectionUuid]="asFormGroup(item).get('uuid')?.value"
              [sectionName]="asFormGroup(item).get('name')?.value"
              [otherThemeListIds]="getOtherThemeListIds(item)"
              [isSelfAuthoringRoleplay]="false"
              (deleteRequested)="handleDeleteTheme($event)"
            ></messaging-theme>
          </div>
        </ng-template>
      </qai-dragable>
    </div>
    <div class="add-theme">
      <button
        qai-button
        [shape]="'normal'"
        [kind]="'tertiary-text'"
        [size]="'medium'"
        [disabled]="readOnly || hasBlankThemeFact()"
        (click)="addTheme($event)"
      >
        <qai-icon kind="plus" size="'20px'" positionStart />
        <span>{{ 'simulationBuilder.ADD_THEME_BUTTON' | transloco }}</span>
      </button>
    </div>
  </details-section>
}
